'use client';

import { useCallback, useEffect } from 'react';
import type { RefObject } from 'react';

const useOutsideClick = (ref: RefObject<HTMLElement | null>, callback: () => void): void => {
  const handleClick = useCallback((e: MouseEvent) => {
    if (ref?.current && !ref?.current?.contains(e?.target as Node)) {
      callback();
    }
  }, [callback, ref]);

  useEffect(() => {
    document?.addEventListener('click', handleClick, true);
    return () => {
      document?.removeEventListener('click', handleClick);
    };
  }, [handleClick]);
};

export default useOutsideClick;
